module.exports = __webpack_public_path__ + "static/media/other-expenditure-1.de608e65.svg";